// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_do-a";
export var fulfillmentFormRail = "_do-9";
export var headerTitleRow = "_do-c";
export var orderDetailsWrapper = "_do-7";
export var orderLinkTrigger = "_do-2";
export var paymentInformationGrid = "_do-h";
export var paymentSummaryColumn = "_do-i";
export var shipmentContainer = "_do-b";
export var shipmentDetailsMainPane = "_do-8";
export var shipmentNavigationCard = "_do-5";
export var shipmentNavigationRail = "_do-3";
export var shipmentNavigationRailHeader = "_do-4";
export var shipmentSummaryFact = "_do-e";
export var shipmentSummaryGrid = "_do-d";
export var shipmentSummaryMetadataRow = "_do-f";
export var shipmentSummaryTags = "_do-g";
export var shipmentWorkspace = "_do-0";
export var shipmentWorkspaceContent = "_do-6";
export var shipmentWorkspaceHeader = "_do-1";